import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import Footer from '../footer/footerbkp';
import Header from '../header/newheader'
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

class ClusterDesc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mission: ''
        }
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    list() {
        Axios(BASE + 'jsonapi/node/research_cluster?sort=title', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    mission: data.data.data
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillMount() {
        this.topFunction();
        //ResrchDiviison
        Axios(BASE + 'jsonapi/block_content/description', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.list()
                this.setState({
                    descrption: data.data.data[0].attributes
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    render() {
        return (
            <div>
                <Header />
                <div className='formrea clusterpage yourwork sub_work'>
                    <div className="listing">
                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="container">
                                    <h1 className="page-header">Research clusters</h1>
                                </div>
                            </div>
                        </div>
                        {this.state.descrption ?
                            <div className="clusterdesc container">
                                {ReactHtmlParser(this.state.descrption.body.value)}
                            </div>
                            : ''}
                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="container">
                                    <h1 className="page-header">Research Clusters</h1>
                                </div>
                            </div>
                        </div>
                        <div className="main-content">
                            <div className="container">
                                <Accordion>
                                    {this.state.mission ? 
                                    this.state.mission.map((inst, index) => {
                                        return (
                                            <AccordionItem  expanded={index === 0 ? true : false}>
                                                <AccordionItemTitle className='accordion__title'>
                                                    <div className='sub'>
                                                        <div className='card-title'>{inst.attributes.title}</div>
                                                        <div class="accordion__arrow1" role="presentation">
                                                        &#43;
                                                        </div>
                                                    </div>
                                                </AccordionItemTitle>
                                                <AccordionItemBody>
                                                    {inst.attributes.title}
                                                </AccordionItemBody>
                                            </AccordionItem>
                                        )
                                    })
                                        : '' }
                                </Accordion>
                                {/* <div className="row">
                                    <div className="region region-content">
                                        <div className="listings">
                                            {this.state.mission ?
                                                <div className="col-sm-4 mission">
                                                    <h4 className="sub_heading">CIS Programs</h4>
                                                    {this.state.mission.map((inst, index) => {
                                                        return (
                                                            <div className="clusterlist">
                                                                <div className="title">
                                                                    <span className="field-content">
                                                                        <Link to={{ pathname: '/project/' + `${inst.attributes.drupal_internal__nid}` }}>
                                                                            {inst.attributes.title}
                                                                        </Link>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div> : <List />
                                            }
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />

            </div>

        )
    }
}

export default ClusterDesc;
